import React from "react";
import { colors } from "../../theme";
import { Logo as logoSrc } from "../../assets/svg";

import {
  StyledHeader,
  LogoWrapper,
  Logo,
  Content,
  ToggleWrapper,
} from "./styled-components";
import { Text, Toggle } from "../../components";
import { ETextVariant, IToggleProps } from "../../types";

interface Props {
  children: React.ReactNode;
  color?: string;
  toggle?: IToggleProps;
}

const Header: React.FC<Props> = ({
  children,
  color = colors.red,
  toggle = null,
}) => {
  return (
    <StyledHeader>
      <LogoWrapper href="https://www.cncef.org/espace-membre/" color={color}>
        <Logo src={logoSrc} />
      </LogoWrapper>
      <Content>
        <Text variant={ETextVariant.Title1}>{children}</Text>
        {toggle ? (
          <ToggleWrapper>
            <Toggle {...toggle} />
          </ToggleWrapper>
        ) : null}
      </Content>
    </StyledHeader>
  );
};

export default Header;
